import { mapGetters } from 'vuex'
import NtrPaslaugosMap from '../components/ntrpaslaugos/NtrPaslaugosMap'
import userRole from './userRole'
export default {
  mixins: [userRole],
  data() {
    return {
      rengiamiLoading: false,
      iregistruotiLoading: true,
      rengiamiLength: 0,
      iregistruotiLength: 0,
      naujasPrasymasLoading: false,
      showNaujasError: false,
      naujasError: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      paslaugaAprasymas: null,
      rengiamiKeyNr: 0,
      iregistruotiKeyNr: 0,
      pagrindasKeyNr: 0,
      showPrasymasRole: false,
      showPrasymasPagrindas: false,
      dokId: null,
    }
  },
  computed: {
    ...mapGetters(['listInfo']),
    pageloading() {
      return this.rengiamiLoading || this.iregistruotiLoading
    },
    prasymasMap() {
      return NtrPaslaugosMap.getPrasymasTipas(this.prasymasKodas)
    },
    prasymasTipas() {
      return this.prasymasMap.tipas
    },
    prasymasTitle() {
      return this.prasymasMap.title
    },
    prasymasRouteList() {
      return this.prasymasMap.routeList
    },
    prasymasRouteEdit() {
      return this.prasymasMap.routeEdit
    },
    prasymasRouteSign() {
      return this.prasymasMap.routeSign
    },
    rengiamiKey() {
      return `rengiami-${this.rengiamiKeyNr}`
    },
    iregistruotiKey() {
      return `iregistruoti-${this.iregistruotiKeyNr}`
    },
    pagrindasKey() {
      return `pagrindas-${this.pagrindasKeyNr}`
    },
  },
  methods: {
    rengiamiLoaded(length) {
      this.rengiamiLength = length
      this.rengiamiLoading = false
    },
    iregistruotiLoaded(length) {
      this.iregistruotiLength = length
      this.iregistruotiLoading = false
    },
    naujasPrasymas(dokId, roleObjekte = null, prasymasPagrindas = null) {
      this.showNaujasError = false
      this.naujasPrasymasLoading = true
      const data = {
        pra_tipas: this.prasymasTipas,
        dok_id: dokId,
        sasm_role_objekte: roleObjekte,
        pra_pagrindas_kla_id: prasymasPagrindas,
      }
      this.$axios
        .post(`ntrpaslaugos/prasymas`, data)
        .then(res => {
          this.editPrasymas(res.data.prasymas)
        })
        .catch(err => {
          this.naujasError = err.response.data.message
          this.showNaujasError = true
          this.iregistruotiKeyNr++
        })
        .finally(() => {
          this.naujasPrasymasLoading = false
        })
    },
    editPrasymas(prasymas, registravimas = false) {
      const prasymasID = prasymas.pra_id
      this.$store.dispatch('prasymasID', prasymasID).then(
        this.$store.dispatch('prasymasTipas', prasymas.pra_tipas).then(() => {
          const listInfo = {
            prasymasID: prasymasID,
            routeName: this.prasymasRouteList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            if (registravimas) {
              this.$router.push({
                name: this.prasymasRouteSign,
                params: {
                  prasymasID: prasymasID,
                  step: 'registravimas',
                },
              })
              return
            }
            this.$router.push({
              name: this.prasymasRouteEdit,
              params: {
                prasymasID: prasymasID,
              },
            })
          })
        })
      )
    },
    showAprasymas(tipas) {
      this.paslaugaAprasymas = tipas
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
    updateList() {
      this.rengiamiKeyNr++
      this.iregistruotiKeyNr++
      this.pagrindasKeyNr++
    },
    openPrasymasRole() {
      this.showPrasymasRole = true
    },
    confirmPrasymasRole(roleObjekte) {
      this.naujasPrasymas(null, roleObjekte)
    },
    openPrasymasPagrindas(dokId) {
      this.showNaujasError = false
      this.dokId = dokId
      this.showPrasymasPagrindas = true
    },
    confirmPrasymasPagrindas(pagrindasId) {
      this.naujasPrasymas(this.dokId, null, pagrindasId)
    },
    cancelPrasymasPagrindas() {
      this.updateList()
    },
  },
}
